import {arc} from '../path/shapes';
import markItemPath from './markItemPath';

export default markItemPath('arc', arc);



//////////////////
// WEBPACK FOOTER
// ./~/vega-scenegraph/src/marks/arc.js
// module id = 1522
// module chunks = 0